import { Cable, Download, History, KeyRound, MonitorSmartphone, Pencil, Smartphone, type LucideIcon } from 'lucide-react';
import type { Permission } from '@quds/shared';
import type { ModalSize } from '@/components/ui';
import type { PharmacyAction } from './types';

/** `permission` is required to open the action; the API enforces the same rule. */
export const ACTION_META: Record<PharmacyAction, { label: string; icon: LucideIcon; size: ModalSize; permission: Permission }> = {
  license: { label: 'Manage License', icon: KeyRound, size: 'md', permission: 'license.read' },
  update: { label: 'Application Update', icon: Download, size: 'lg', permission: 'update.read' },
  api: { label: 'API & Integration', icon: Cable, size: 'lg', permission: 'api.read' },
  devices: { label: 'Manage Devices', icon: MonitorSmartphone, size: 'lg', permission: 'device.read' },
  mobile: { label: 'Mobile App Access', icon: Smartphone, size: 'md', permission: 'mobile.read' },
  edit: { label: 'Edit Pharmacy', icon: Pencil, size: 'lg', permission: 'pharmacy.update' },
  activity: { label: 'Activity Log', icon: History, size: 'lg', permission: 'activity.read' },
};

/** Menu order for the row Actions menu. */
export const ACTION_ORDER: readonly PharmacyAction[] = ['license', 'update', 'api', 'devices', 'mobile', 'edit', 'activity'];
